<template>
  <div class="m3 my3 center">
    <h1> {{ getReferencelabel("HOW_IT_WORKS") }} </h1>
    <div v-for="content of displayData" v-if="displayData && displayData.length">
      <div v-if="!content.display_content_type" v-html="getConfigurationContent(content)"> </div>
      <DisplayContent v-else :content="content" />
    </div>
  </div>
</template>

<script>

import { computed } from 'vue';
import { useStore } from 'vuex';
import { useRoute } from 'vue-router';
import DisplayContent from '@/components/elements/DisplayContent.vue';

import { getReferencelabel, getConfigurationContent } from '@/mixins/utils';

export default {
  components: { DisplayContent },
  setup () {
    const store = useStore();
    const route = useRoute();

    const displayData = computed(() => store.getters.getSiteConfiguration('display_content', 'SPONSOR_HELP_PAGE'));

    return { getReferencelabel, displayData, getConfigurationContent };
  }
};
</script>

<style>

</style>
